// Input mask utilities with TypeScript
export const formatWhatsApp = (value: string): string => {
  // Remove all non-numeric characters
  const numericValue = value.replace(/\D/g, "");

  // Apply WhatsApp format: (XX) XXXXX-XXXX
  if (numericValue.length <= 2) {
    return `(${numericValue}`;
  } else if (numericValue.length <= 7) {
    return `(${numericValue.slice(0, 2)}) ${numericValue.slice(2)}`;
  } else {
    return `(${numericValue.slice(0, 2)}) ${numericValue.slice(
      2,
      7
    )}-${numericValue.slice(7, 11)}`;
  }
};

export const validateWhatsApp = (phone: string): boolean => {
  // Remove all non-numeric characters
  const numericPhone = phone.replace(/\D/g, "");

  // Brazilian mobile numbers have 10-11 digits
  return numericPhone.length >= 10 && numericPhone.length <= 11;
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateName = (name: string): boolean => {
  return name.trim().length >= 2 && /^[a-zA-ZÀ-ÿ\s]+$/.test(name);
};

export const cleanPhoneNumber = (phone: string): string => {
  return phone.replace(/\D/g, "");
};
